export const quranTrackingAr = {
  // Quran progress
  lastSession: 'آخر جلسة',
  nextSession: 'الجلسة القادمة',
  note: 'الملاحظة',
  
  // Hifz (الحفظ) - Mémorisation
  newHifzTxt: 'الحفظ الجديد',
  nextHalaqaNewHifzText: 'الحفظ الجديد',
  
  // Murajah (المراجعة) - Révision
  oldHifzMurajahTxt: 'مراجعة الحفظ القديم',
  newHifzMurajahText: 'مراجعة الحفظ القريب',
  nextHalaqaOldHifzMurajahText: 'مراجعة الحفظ القديم',
  nextHalaqaNewHifzMurajahText: 'مراجعة الحفظ القريب ',

  // Actions & labels
  absent: 'غائب',
  edit: 'تعديل',
  cancel: 'إلغاء',
  save: 'حفظ',
  saving: 'جاري...',
  savingEvals: 'جاري الحفظ...',
  evaluation: 'تقييم',
  repeatLastHifz: 'تكرار آخر حفظ',
  repeatNewHifzLabel: 'تكرار الحفظ الجديد',
  times: 'مرة',
  mustRepeatPart1: 'يجب على الطالب تكرير الحفظ الجديد',
  mustRepeatPart2: 'ثم تحديث القيمة',
  sortByLastSession: 'تاريخ إنشاء آخر جلسة',

  // Evaluation options
  evalExcellent: 'ممتاز',
  evalGood: 'جيد',
  evalMoyen: 'متوسط',
  evalRepeat: 'إعادة',
  evalAbsent: 'غائب',
  evalNotDone: 'لم يتم',
};
